/**
 * Created by rathompson on 5/9/22
 * File: DeviceReducer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import {
  LOAD_CSP_DEVICES,
  LOAD_DEVICES,
} from './actions/DeviceReducer.actions'

const initState = {
  devices: [],
  cspDevices: []
}

const DeviceReducer = (state = initState, action) => {
  switch (action.type) {
    case LOAD_DEVICES: {
      return { ...state, devices: action.devices }
    }
    case LOAD_CSP_DEVICES: {
      return { ...state, cspDevices: action.cspDevices }
    }
    default: {
      return state
    }
  }
}

DeviceReducer.initialState = initState
export default DeviceReducer
